var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "url(#paint0_linear_1_12690)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4318 19.0959V26.9525C26.4318 27.2362 26.3336 27.4817 26.1371 27.689C25.9407 27.8963 25.7081 28 25.4394 28H19.4848V21.7147H15.5152V28H9.56065C9.29187 28 9.05927 27.8963 8.86285 27.689C8.66644 27.4817 8.56823 27.2362 8.56823 26.9525V19.0959C8.56823 19.085 8.57081 19.0686 8.57598 19.0468C8.58115 19.0249 8.58374 19.0086 8.58374 18.9977L17.5 11.2393L26.4163 18.9977C26.4266 19.0195 26.4318 19.0522 26.4318 19.0959ZM29.8897 17.9665L28.9283 19.1777C28.8456 19.2759 28.7371 19.3359 28.6027 19.3578H28.5562C28.4218 19.3578 28.3132 19.3196 28.2305 19.2432L17.5 9.79891L6.76947 19.2432C6.64542 19.3305 6.52136 19.3687 6.39731 19.3578C6.26292 19.3359 6.15438 19.2759 6.07167 19.1777L5.11027 17.9665C5.02757 17.8574 4.99139 17.7292 5.00172 17.5818C5.01206 17.4345 5.06892 17.3172 5.17229 17.2299L16.3215 7.42557C16.6523 7.14186 17.0451 7 17.5 7C17.9549 7 18.3477 7.14186 18.6785 7.42557L22.4621 10.7646V7.57288C22.4621 7.42011 22.5086 7.29462 22.6017 7.19641C22.6947 7.09821 22.8136 7.0491 22.9583 7.0491H25.9356C26.0803 7.0491 26.1992 7.09821 26.2922 7.19641C26.3853 7.29462 26.4318 7.42011 26.4318 7.57288V14.251L29.8277 17.2299C29.9311 17.3172 29.9879 17.4345 29.9983 17.5818C30.0086 17.7292 29.9724 17.8574 29.8897 17.9665Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_12690",
    x1: 4.83645,
    y1: 4.72732,
    x2: 38.2596,
    y2: 32.6211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#564AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14086D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboardLogo.947be572bf74061e05a12cfa308fdb43.svg";
export { ForwardRef as ReactComponent };